import IconBatteryRed from "../assets/icons/battery-red.svg";
import IconBatteryOrange from "../assets/icons/battery-orange.svg";
import IconBatteryYellow from "../assets/icons/battery-yellow.svg";
import IconBatteryLime from "../assets/icons/battery-lime.svg";
import IconBatteryGreen from "../assets/icons/battery-green.svg";
import IconBatteryOff from "../assets/icons/battery-off.svg";
import {TBattery} from "../pages/Dashboard/Dashboard.type";
import {batteryToLevel, normalizeBattery} from "./batteryMaturity";
import {GARTNER_BATTERY_PHASES} from "../components/SidebarCard/SidebarCardUI/GartnerCharts/constants";

/** Filter cycle index 1..5 → phase label. */
export const batteryFilterValueByIndex = (index: number): TBattery | 0 => {
  if (index < 1 || index > 5) return 0;
  return GARTNER_BATTERY_PHASES[index - 1];
};

/** Icon for filter state 0..5 (0 = off). */
export const getBatteryIconByFilterState = (state: number): string => {
  switch (state) {
    case 1:
      return IconBatteryRed;
    case 2:
      return IconBatteryOrange;
    case 3:
      return IconBatteryYellow;
    case 4:
      return IconBatteryLime;
    case 5:
      return IconBatteryGreen;
    case 0:
    default:
      return IconBatteryOff;
  }
};

/** Icon for a stored battery phase label (incl. legacy CMS values). */
export const getBatteryIconByPhase = (
  battery?: TBattery | null
): string => {
  if (!battery) return IconBatteryOff;
  const level = batteryToLevel(normalizeBattery(battery));
  if (!level) return IconBatteryRed;
  return getBatteryIconByFilterState(level);
};
